import { Component, computed, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { ColumnRendererComponentV3 } from '@gea/digital-ui-lib';
interface ProbabilityOfFailure {
  probablity_of_failure: number;
  last_notified_probability: number;
}
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-probability-of-failure',
  imports: [DecimalPipe],
  styles: `
    .table-container-section {
      min-width: 0;
      min-height: 0;
      width: fit-content;
      padding: 4px 8px;
      border-radius: 6px;
    }
  `,
  template: `
    <div [style.backgroundColor]="bgColor()" [style.color]="color()" class="table-container-section">
      {{ probablityOfFailureValue() | number: '1.0-0' }}%

      @if (probabilityDifference() !== null) {
        <span> ({{ probabilityDifference()! > 0 ? '+' : '' }}{{ probabilityDifference() }}%) </span>
      }
    </div>
  `,
})
export class ProbablityOfFailureComponent implements ColumnRendererComponentV3<ProbabilityOfFailure> {
  readonly rowData = input<ProbabilityOfFailure | null>(null);
  readonly columnKey = input<keyof ProbabilityOfFailure>('probablity_of_failure');
  readonly lastNotifiedProbabilitycolumnKey = input<keyof ProbabilityOfFailure>('last_notified_probability');

  probablityOfFailureValue = computed(() => {
    const data = this.rowData();
    const v = data?.[this.columnKey()];
    return v;
  });

  probabilityDifference = computed(() => {
    const data = this.rowData();
    const current = data?.[this.columnKey()];
    const last = data?.[this.lastNotifiedProbabilitycolumnKey()];
    if (current == null || last == null) return null;
    return Math.round((current - last) * 100);
  });

  bgColor = computed(() => {
    const val = this.probablityOfFailureValue();
    if (val == null) return 'inherit';
    if (val > 65) return '#fce8e8';
    if (val <= 65) return '#fff8e1';
    return;
  });

  color = computed(() => {
    const val = this.probablityOfFailureValue();
    if (val == null) return 'inherit';
    if (val > 65) return '#dc3545';
    if (val <= 65) return '#ffc107';
    return;
  });
}
